module.exports = __webpack_public_path__ + "static/media/pitpay-logo.54085f95.png";